import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';

export const advertisingPlatformNames: {[key in AdvertisingPlatformCodeEnum]: string} = {
  [AdvertisingPlatformCodeEnum.SAUTO]: 'SAuto',
  [AdvertisingPlatformCodeEnum.TIPCARS]: 'TipCars',
  [AdvertisingPlatformCodeEnum.MOBILE_DE]: 'Mobile.de',
  [AdvertisingPlatformCodeEnum.MYWEB]: 'My Web',
  [AdvertisingPlatformCodeEnum.FACEBOOK]: 'Facebook',
  [AdvertisingPlatformCodeEnum.AUTOSOFT]: 'Autosoft',
  [AdvertisingPlatformCodeEnum.AUTOCARIS]: 'AutoCaris',
  [AdvertisingPlatformCodeEnum.OTOMOTO]: 'Otomoto',
  [AdvertisingPlatformCodeEnum.OLX]: 'Olx',
  [AdvertisingPlatformCodeEnum.SKODA_PLUS]: 'Škoda Plus',
  [AdvertisingPlatformCodeEnum.DAS_WELT_AUTO]: 'Das WeltAuto',
  [AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE]: 'Mercedes na skladě',
  [AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE_REST]: 'Mercedes na skladě REST',
  [AdvertisingPlatformCodeEnum.HYUNDAI_PROMISE]: 'Hyundai Promise',
  [AdvertisingPlatformCodeEnum.FORD_UZYWANE]: 'Ford Używane',
  [AdvertisingPlatformCodeEnum.AUTOPLAC_PL]: 'Autoplac.pl',
  [AdvertisingPlatformCodeEnum.VEHIS]: 'Vehis',
  [AdvertisingPlatformCodeEnum.MAMGO]: 'BNP Paribas | MamGO',
  [AdvertisingPlatformCodeEnum.FORD_GERONIMO]: 'Ford Geronimo',
  [AdvertisingPlatformCodeEnum.SAMOCHODY_PL]: 'Samochody.pl',
  [AdvertisingPlatformCodeEnum.VGP]: 'Volkswagen Group Polska',
  [AdvertisingPlatformCodeEnum.AUDI_PL]: 'Audi Polska',
  [AdvertisingPlatformCodeEnum.FINDCAR_PL]: 'FindCar.pl',
};
